import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../button/Button';
import { ASSESSMENT_TYPE, ASSESSMENT_TYPE_LABELS } from '../../constants/assessments';
import { assessmentTypeType } from '../../constants/prop-types';
import { useAppContext } from '../../common/contexts/AppContext';

const changeAssessmentType = (setAssessmentType, type) => () => {
    setAssessmentType(type);
};

const AssessmentTypeButton = ({ assessmentType, isEnabled, setAssessmentType }) => {
    const { selectedAssessmentType } = useAppContext();

    const cssClasses = classNames('dashboard-assessment-type-button', {
        'dashboard-bm': assessmentType === ASSESSMENT_TYPE.BM,
        'dashboard-pm': assessmentType === ASSESSMENT_TYPE.PM,
        'dashboard-selected': assessmentType === selectedAssessmentType,
        'dashboard-disabled': !isEnabled,
    });

    return (
        <Button
            onClick={changeAssessmentType(setAssessmentType, assessmentType)}
            isEnabled={isEnabled}
            cssClasses={cssClasses}
        >
            {ASSESSMENT_TYPE_LABELS[assessmentType]}
        </Button>
    );
};

AssessmentTypeButton.propTypes = {
    assessmentType: assessmentTypeType,
    isEnabled: PropTypes.bool,
    setAssessmentType: PropTypes.func,
};

AssessmentTypeButton.defaultProps = {
    assessmentType: ASSESSMENT_TYPE.BM,
    isEnabled: true,
    setAssessmentType: () => {},
};

export default AssessmentTypeButton;
